import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/playlist";

class PlaylistService {
  getPlaylists = async ({ page = 1, search, filter }) => {
    try {
      let url = `${BASE_URL}/?page=${page}`;

      if (search && search.trim() !== "") {
        url += `&search=${encodeURIComponent(search)}`;
      }

      if (filter && filter.trim() !== "") {
        url += `&filter=${encodeURIComponent(filter)}`;
      }

      const response = await axiosApiClient.get(url);

      if (response.status !== 200) {
        throw new Error();
      }

      const data = response.data;
      return data;
    } catch (err) {
      console.log(err);
      throw handleError(err, "Error occurred while fetching playlists.");
    }
  };

  getMyPlaylists = async () => {
    try {
      let url = `${BASE_URL}/user`;

      const response = await axiosApiClient.get(url);

      if (response.status !== 200) {
        throw new Error();
      }

      const data = response.data;
      return data;
    } catch (err) {
      console.log(err);
      throw handleError(err, "Error occurred while fetching playlists.");
    }
  };

  getPlaylist = async ({ page = 1, playlistId }) => {
    try {
      let url = `${BASE_URL}/${playlistId}?page=${page}`;

      const response = await axiosApiClient.get(url);

      if (response.status !== 200) {
        throw new Error();
      }

      const data = response.data;
      return data;
    } catch (err) {
      console.log(err);
      throw handleError(err, "Error occurred while fetching playlist.");
    }
  };

  createPlaylist = async ({ name, isPublic }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, {
        name,
        isPublic,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      const data = response.data.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating playlist.");
    }
  };

  editPlaylist = async ({ name, collections, playlistId }) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/${playlistId}`, {
        name,
        collections,
      });
      if (response.status !== 200) {
        throw new Error();
      }

      const data = response.data.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while editing playlist.");
    }
  };

  deletePlaylist = async ({ playlistId }) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${playlistId}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const data = response.data?.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting playlist.");
    }
  };

  toggleToFavorite = async ({ playlistId }) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/favorite/${playlistId}`,
      );
      if (response.status !== 201) {
        throw new Error();
      }

      return playlistId;
    } catch (err) {
      throw handleError(err, "Error occurred while toggle to favorite");
    }
  };

  addCollectionToPlaylist = async ({ playlistIds, collectionId }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/collection`, {
        playlistIds,
        collectionId,
      });
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while adding playlist to collection",
      );
    }
  };
}

const playlistService = new PlaylistService();

export default playlistService;
